import { type FC } from "react";
import { Routes, Route } from "react-router-dom";
import { LoginPage } from "../pages/LoginPage/LoginPage";
import { RegisterPage } from "../pages/RegisterPage/RegisterPage";
import { HomePage } from "../pages/HomePage/HomePage";
import { GastosDiarios } from "../pages/UsersPage/GastosDiarios";
import { EstadisticasPage } from "../pages/Estadisticas/EstadisticasPage";
import { useAuthState } from "../context/AppContext";
import { auth } from "../firebase/firebaseConfig";
import type { AppRouterProps } from "./types";

export const AppRouter: FC<AppRouterProps> = () => {
  const { isUserDataResolved } = useAuthState();

  if (!isUserDataResolved) {
    return null;
  }

  return auth.currentUser ? (
    <Routes>
      <Route path="/registerAdm" element={<RegisterPage />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/" element={<HomePage />} />
      <Route path="/gastos-diarios" element={<GastosDiarios />} />
      <Route path="/estadisticas" element={<EstadisticasPage />} />
    </Routes>
  ) : (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<LoginPage />} />
    </Routes>
  );
};
